"use client";

import { Label as RadixLabel } from "radix-ui";
import type { ComponentPropsWithRef } from "react";
import { cn } from "@/core/shared/v2/lib/utils";

const { Root } = RadixLabel;

export interface LabelProps extends ComponentPropsWithRef<typeof Root> {}

const labelClass = cn(
  "select-none items-center gap-2 font-medium text-foreground text-sm leading-none",
  "peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
);

export function Label({ className, ...props }: LabelProps) {
  return <Root data-slot="label" className={cn(labelClass, className)} {...props} />;
}
